import { GET_BLOG, GET_BLOGS, ADD_BLOG, ADD_BLOG_ERR, PUBLISH_BLOG, DELETE_BLOG, DISPLAY_BLOG, TOTAL_BLOG, SET_RELATED_POPUP_VISIBLE, GET_RELATED_PRODUCT, BLOG_SHARE, CONTENT_POPUP_VISIBLE, GET_BLOGS_V3, SET_BLOG_LOADING } from "../actions/blog/type";
// import _ from 'lodash';

const initState = { blogs: [], blog_id: null, blog: null, totalBlogs: null, displayBlogResult: null, blogsV3: null, curPage: 1, sort: null, sortColumn: 'created_date', sortOrder: 'DESC', publishResult: null, addResult: null, addError: null, editResult: null, deleteResult: null, relatedPopupVisible: false, shareBlogResult: null, content_popup_visible: null, content_index: 0, edit_content: null, content: null, isLoading: false }
export default function (state = initState, action) {
    switch (action.type) {
        case SET_BLOG_LOADING:
            return { ...state, isLoading: action.payload }
        case GET_BLOG:
            return { ...state, content: action.payload, isLoading: false }
        case GET_BLOGS:
            if (action.payload) {
                return { ...state, blogs: action.payload.blogs, sortColumn: action.payload.sortColumn, sortOrder: action.payload.sortOrder, search: action.payload.search, curPage: action.payload.curPage }
            } else {
                return { ...state }
            }
        case GET_BLOGS_V3:
            return { ...state, blogsV3: action.payload }
        case ADD_BLOG:
            return { ...state, addResult: action.payload.addResult }
        case ADD_BLOG_ERR:
            return { ...state, addError: action.payload, addResult: false }
        case PUBLISH_BLOG:
            return { ...state, publishResult: action.payload.publishResult }
        case DELETE_BLOG:
            return { ...state, deleteResult: action.payload.deleteResult }
        case DISPLAY_BLOG:
            return { ...state, displayBlogResult: action.payload ? action.payload.blogs : null, curPage: action.payload ? action.payload.curPage : null, sortType: action.payload ? action.payload.sortType : null, sortOrder: action.payload ? action.payload.sortOrder : null }
        case TOTAL_BLOG:
            return { ...state, totalBlogs: action.payload }
        case SET_RELATED_POPUP_VISIBLE:
            return { ...state, relatedPopupVisible: action.payload }
        case GET_RELATED_PRODUCT:
            return { ...state, listRelatedProduct: action.payload }
        case BLOG_SHARE:
            return { ...state, shareBlogResult: action.payload }
        case CONTENT_POPUP_VISIBLE:
            return { ...state, content_popup_visible: action.payload.value, content_index: action.payload.index >= 0 ? action.payload.index : null, edit_content: action.payload.content }
        default:
            return state;
    }

}